module.exports = __webpack_public_path__ + "img/golfCar.1c1d2574.png";